import React, { Fragment, useState } from "react";
import * as uuid from "uuid";
import _ from "lodash";
import { Form, Col, Row, Card, Button } from "react-bootstrap";

import useValidation from "../../../../../util/useValidation";
import FamilyDetailsForm from "./FamilyDetailsForm";
import {
  alphabetWithSpacePattern,
  mobileNumberPattern,
  defaultRelationShipList
} from "../../../../../constants/constants";
import { relationObject } from "../../../../../constants/candidateDataObjects";
import {
  getRelationDetails,
  getRelationShipName
} from "../../../../../util/onBoardingDataFilters";

const EmergencyContactAndFamilyBgr = ({
  personalDetails,
  relationShipList,
  addRelationDetails,
  deleteRelationDetails,
  updatePersonalDetails
}) => {
  const familyMembers = personalDetails.familyMembers
    ? personalDetails.familyMembers
    : [];
  const [addRelationShipBtn, setAddRelationShipBtn] = useState(false);
  const { handleOnBlurValidation, errors } = useValidation();

  const handleOnBlurInput = e => {
    handleOnBlurValidation(e);
  };

  const getNonDefaultRelationShipList = isSelected => {
    const defaultRelationTypes = _.map(defaultRelationShipList, "id");
    const selectedRelationTypes = familyMembers.length
      ? _.map(familyMembers, "relationShipType")
      : [];
    return isSelected
      ? familyMembers.filter(
          relation => !defaultRelationTypes.includes(relation.relationShipType)
        )
      : relationShipList.filter(
          relation =>
            !(
              defaultRelationTypes.includes(relation.id) ||
              selectedRelationTypes.includes(relation.id)
            )
        );
  };

  const handleOnSelectedRelationship = ({ target: { value } }) => {
    const defaultRelationObj = relationObject();
    const newRelation = {
      ...defaultRelationObj,
      id: `temp_${uuid.v4()}`,
      candidateId: personalDetails.id,
      relationShipType: +value
    };
    addRelationDetails(newRelation);
    setAddRelationShipBtn(false);
  };

  const handleOnChangePersonalDetails = ({ target: { name, value } }) => {
    updatePersonalDetails(name, value);
  };
  const handleOnDeleteFamilyDetails = relationID => {
    deleteRelationDetails(relationID);
  };
  const handleOnChangeFamilyDetails = (
    { target: { name, value } },
    relationShipTypeId,
    relationDetails
  ) => {
    name = name.replace(relationShipTypeId, "");
    if (!_.isEmpty(relationDetails) && relationDetails.id) {
      updatePersonalDetails(
        name,
        value.trimStart(),
        "familyMembers",
        relationDetails.id
      );
    } else {
      const defaultRelationObj = relationObject();
      const newRelation = {
        ...defaultRelationObj,
        id: `temp_${uuid.v4()}`,
        candidateId: personalDetails.id,
        relationShipType: relationShipTypeId,
        [name]: value.trimStart()
      };
      addRelationDetails(newRelation);
    }
  };

  return (
    <Fragment>
      <Card>
        <Card.Header>Emergency Contact Details</Card.Header>
        <Card.Body>
          <Form.Group as={Row} controlId="contactNameRelationshipToEmployee">
            <Col sm={4}>
              <Form.Label>Contact Name*</Form.Label>
              <Form.Control
                size="sm"
                required
                type="text"
                name="emergencyPersonName"
                placeholder="Contact Name"
                value={personalDetails.emergencyPersonName}
                pattern={alphabetWithSpacePattern}
                onChange={handleOnChangePersonalDetails}
                onBlur={handleOnBlurInput}
                isInvalid={errors.emergencyPersonName}
              />
              {errors.emergencyPersonName && (
                <Form.Control.Feedback type="invalid">
                  {errors.emergencyPersonName.type === "required" &&
                    "Contact Name is required"}
                  {errors.emergencyPersonName.type === "pattern" &&
                    "Must contain only alphabets and space"}
                </Form.Control.Feedback>
              )}
            </Col>
            <Col sm={4}>
              <Form.Label>Relationship to Employee*</Form.Label>
              <Form.Control
                size="sm"
                required
                type="text"
                name="relationWithMe"
                placeholder="Relationship to Employee"
                value={personalDetails.relationWithMe}
                pattern={alphabetWithSpacePattern}
                onChange={handleOnChangePersonalDetails}
                onBlur={handleOnBlurInput}
                isInvalid={errors.relationWithMe}
              />
              {errors.relationWithMe && (
                <Form.Control.Feedback type="invalid">
                  {errors.relationWithMe.type === "required" &&
                    "Relationship is required"}
                  {errors.relationWithMe.type === "pattern" &&
                    "Must contain only alphabets and space"}
                </Form.Control.Feedback>
              )}
            </Col>
            <Col sm={4} />
          </Form.Group>

          <Form.Group as={Row} controlId="homeNumberMobleNumber">
            <Col sm={4}>
              <Form.Label>Mobile Number*</Form.Label>
              <Form.Control
                size="sm"
                required
                type="text"
                name="emergencyContactNo"
                placeholder="Contact Number"
                value={personalDetails.emergencyContactNo}
                pattern={mobileNumberPattern}
                onChange={handleOnChangePersonalDetails}
                onBlur={handleOnBlurInput}
                isInvalid={errors.emergencyContactNo}
              />
              {errors.emergencyContactNo && (
                <Form.Control.Feedback type="invalid">
                  {errors.emergencyContactNo.type === "required" &&
                    "Contact Number is required"}
                  {errors.emergencyContactNo.type === "pattern" &&
                    "Please enter a valid Contact Number"}
                </Form.Control.Feedback>
              )}
            </Col>
            <Col sm={4}>
              <Form.Label>Home Number*</Form.Label>
              <Form.Control
                size="sm"
                required
                type="text"
                name="emergencyHomeNumber"
                placeholder="Home Number"
                value={personalDetails.emergencyHomeNumber}
                pattern={mobileNumberPattern}
                onChange={handleOnChangePersonalDetails}
                onBlur={handleOnBlurInput}
                isInvalid={errors.emergencyHomeNumber}
              />
              {errors.emergencyHomeNumber && (
                <Form.Control.Feedback type="invalid">
                  {errors.emergencyHomeNumber.type === "required" &&
                    "Mobile Number is required"}
                  {errors.emergencyHomeNumber.type === "pattern" &&
                    "Please enter a valid Mobile Number"}
                </Form.Control.Feedback>
              )}
            </Col>
            <Col sm={4} />
          </Form.Group>
        </Card.Body>
      </Card>
      <Card className="mt-2">
        <Card.Header>Family Background Details</Card.Header>
        <Card.Body>
          {defaultRelationShipList.map(relation => (
            <FamilyDetailsForm
              fatherName={personalDetails.fatherName}
              relationShipTypeId={relation.id}
              relationshipName={getRelationShipName(
                relation.id,
                relationShipList
              )}
              relation={getRelationDetails(relation.id, familyMembers)}
              handleOnChangeFamilyDetails={handleOnChangeFamilyDetails}
            />
          ))}
          {getNonDefaultRelationShipList(true).map(relation => (
            <FamilyDetailsForm
              relationShipTypeId={relation.id}
              relationshipName={getRelationShipName(
                relation.relationShipType,
                relationShipList
              )}
              relation={relation}
              showDeleteButton={true}
              spouseName={personalDetails.spouseName}
              handleOnChangeFamilyDetails={handleOnChangeFamilyDetails}
              handleOnDeleteFamilyDetails={handleOnDeleteFamilyDetails}
            />
          ))}
          <Row>
            <Col sm={3}>
              <Button
                onClick={() => {
                  setAddRelationShipBtn(true);
                }}
              >
                Add Other Relationship
              </Button>
            </Col>
            {addRelationShipBtn && (
              <Col sm={2}>
                <Form.Control
                  size="sm"
                  required
                  as="select"
                  name="addRelationShipBtn"
                  onChange={handleOnSelectedRelationship}
                >
                  <option>Choose..</option>
                  {getNonDefaultRelationShipList(false).map(relation => (
                    <option value={relation.id}>
                      {relation.relationShipType}
                    </option>
                  ))}
                </Form.Control>
              </Col>
            )}
          </Row>
        </Card.Body>
      </Card>
    </Fragment>
  );
};

export default EmergencyContactAndFamilyBgr;
